import {SCORMContent, SimpleFile} from "../../../../../domain/entities/content/content";
import {Content, ScormCheckpoint} from "../../../../presentation/views/content/helpers";
import {ActionContext} from "vuex";
import {ContentState, getCurrentContent} from "./content_module";
import {stringify} from "../../../../presentation/components/mixins";

export class ScormState {
  scorm: SimpleFile | null = null;
  scormContent: SCORMContent | null = null;
}

const state = new ScormState();

const mutations = {
  SET_SCORM(state: ScormState, scorm: SimpleFile) {
    state.scorm = scorm;
  },

  SET_SCORM_CONTENT(state: ScormState, scormContent: SCORMContent) {
    state.scormContent = scormContent;
  },

  SET_VALUE(state: ScormState, scormCheckpoint: ScormCheckpoint) {
    if (!state.scormContent) return;
    state.scormContent.set(scormCheckpoint.key, scormCheckpoint.value);
  }
};

type ScormActionContext = ActionContext<ScormState, ContentState>
const actions = {
  async initialize(ctx: ScormActionContext) {
    const content = getCurrentContent(ctx);
    loadSCORM(ctx, content);
    loadSCORMContent(ctx, content);
  },

  async setValue(ctx: ScormActionContext, scormCheckpoint: ScormCheckpoint) {
    ctx.commit("SET_VALUE", scormCheckpoint);
  },
};

const loadSCORM = (ctx: ScormActionContext, content: Content) => {
  ctx.commit("SET_SCORM", content.file);
};

const loadSCORMContent = (ctx: ScormActionContext, content: Content) => {
  const checkpoints = content.status.scormCheckpoints;
  const scormContent = new Map<string, string | Object>();

  if (checkpoints) {
    for (let it of checkpoints) {
      scormContent.set(stringify(it.key), stringify(it.value));
    }
  }

  ctx.commit("SET_SCORM_CONTENT", scormContent);
}

const getters = {
  scorm: (state: ScormState) => state.scorm,
  scormContent: (state: ScormState) => state.scormContent,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};